import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/common/main.scss'
import '@/common/tablet.scss'
import LeftMenu from '@/components/LeftMenu.vue'
import WordBookDialog from '@/components/WordBookDialog.vue'
import LearningCompletedDialog from '@/components/LearningCompletedDialog.vue'
import Definition from '@/components/Definition.vue'
import * as echarts from 'echarts'

Vue.config.productionTip = false


Vue.config.errorHandler = (err, vm, info) => {
  
  if (err.response || err.isAxiosError) {
    
    console.error("API Error (已处理):", err.message);
    return;
  }
  
  console.error("Vue Error:", err, info);
}

Vue.use(ElementUI)


Vue.prototype.$echarts = echarts


Vue.prototype.$bus = new Vue()


Vue.component('LeftMenu', LeftMenu)
Vue.component('WordBookDialog', WordBookDialog)
Vue.component('LearningCompletedDialog', LearningCompletedDialog)
Vue.component('Definition', Definition)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
